/** @format */

import Sync from "@croco/sync";
import * as dummy from "./mock-data.js";

class Textarea {
  constructor() {
    this.inputType = "edit";
    this.editText = "";
    this.urlText = "";
    this.url = "";
    this.domainRestricted = false;
    this.domainRestrictedDirection = "";
    this.similarityCheck = "";
    this.domains = [];
  }

  addDomain(url) {
    if (
      !url.match(/^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/)
    ) {
      return "※正しいURLを入力してください。";
    }
    if (this.domains.filter((e) => e == url).length != 0) {
      return "※既に追加されています。";
    }
    this.domains.push(url);
  }

  removeDomain(index) {
    this.domains.splice(index, 1);
  }

  getText() {
    return this.inputType == "edit" ? this.editText : this.urlText;
  }

  valid() {
    let res = [];
    const text = this.getText();
    const textProp = this.inputType + "Text";
    if (text == "") {
      res.push({ prop: textProp, error: ["テキストが入力されていません。"] });
    }
    if (text.length > 20000) {
      res.push({
        prop: textProp,
        error: ["テキストは20000文字以下で入力してください"],
      });
    }

    return res.length == 0
      ? null
      : res.reduce((acc, cur) => {
          acc[cur.prop] = cur.error;
          return acc;
        }, {});
  }
}

class Upload {
  constructor() {
    this.files = [];
    this.urls = [];
  }

  addFile(files) {
    for (let file of files) {
      if (this.files.filter((e) => e.name == file.name).length != 0) {
        continue;
      }
      // blob取得関数追加
      file.getBlob = () => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.addEventListener(
            "load",
            () => {
              fetch(reader.result, {
                method: "GET",
                cache: "no-cache",
              }).then((r) => resolve(r.blob()));
            },
            false
          );
          reader.readAsDataURL(file);
        });
      };
      this.files.push(file);
    }
  }

  addUrl(url) {
    if (
      !url.match(/^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/)
    ) {
      return "※正しいURLを入力してください。";
    }
    if (this.urls.filter((e) => e == url).length != 0) {
      return "※既に追加されています。";
    }
    this.urls.push(url);
  }

  valid() {
    let errors = {};
    if (this.files.length == 0 && this.urls.length == 0) {
      errors["total"] = "一括で取得したい文章を選択してください。";
    }
    if (this.files.length > 20) {
      errors["files"] = "ファイルは一度に20件まで可能です。";
    }
    if (this.urls.length > 20) {
      errors["urls"] = "URLは一度に20件まで可能です。";
    }
    return errors;
  }
}

class TicketRequire {
  constructor() {
    this.count = 0;
    this.length = 0;
    this.ids = [];
    this.msg = "";
    this.isShortage = false;
  }

  /**
   * ticketcount
   * @param {object} data
   * @param {number} tickets
   */
  set(data, tickets) {
    this.count = data.count;
    this.length = data.length;
    this.ids = data.id ? [data.id] : [];
    this.msg = data.msg;

    // チケット不足
    this.isShortage = tickets < this.count;
  }

  /**
   * Set Upload List
   * @param {object} list
   * @param {boolean} similarityCheck
   * @param {number} tickets
   */
  setUploadList(list, similarityCheck, tickets) {
    const data = list.reduce(
      (acc, cur) => {
        if (cur.id && cur.checked) {
          acc.ids.push(cur.id);
          acc.count += cur.count * (similarityCheck ? 2 : 1);
          acc.length += cur.length;
        }
        return acc;
      },
      { count: 0, length: 0, ids: [] }
    );
    this.count = data.count;
    this.length = data.length;
    this.ids = data.ids;

    // 選択なし
    this.msg =
      this.length == 0 && this.count == 0
        ? "一括で取得したい文章を選択してください。"
        : "";

    // チケット不足
    this.isShortage = tickets < this.count;
  }
}

class Mock {
  /**
   * URL入力
   * @param {string} url 入力されたURL
   */
  requestUrlContent(url) {
    console.log({ url });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (url.match(/^http/)) {
          resolve({
            success: true,
            text: dummy.accepts[2].summary,
          });
        } else {
          resolve();
        }
      }, 500);
    });
  }

  /**
   * チケット数モーダル表示
   * @param {number} type 1:旧影武者のみ　2:類似チェックあり
   * @param {string} text 解析元TEXT
   */
  requestTicketRequired(type, text) {
    console.log({ type, text });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          success: true,
          length: text.length,
          count: 100,
          id: 123,
        });
      }, 500);
    });
  }

  /**
   * チケット確認後　解析スタート
   * @param {number} id データ保存ID
   * @param {string[]} sitesサイトリスト
   */
  register(ids, sites) {
    console.log({ ids, sites });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ success: true });
      }, 500);
    });
  }

  /**
   * 文書一括取得
   * @param {Upload} upload
   */
  async requestTexts(upload) {
    console.log({ upload });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ success: true, count: 6, list: dummy.uploads });
      }, 500);
    });
  }
}

class Api extends Sync {
  constructor() {
    super();
    this.api = "/ap/v1/inputs/";
  }

  /**
   * URL入力
   * @param {string} url 入力されたURL
   */
  requestUrlContent(url) {
    return this.post(this.api + "url/", { url });
  }

  /**
   * チケット数モーダル表示
   * @param {number} type 1:旧影武者のみ　2:類似チェックあり
   * @param {string} text 解析元TEXT
   */
  requestTicketRequired(type, text) {
    return this.post(this.api + "ticketcount/", { type, text });
  }

  /**
   * チケット確認後　解析スタート
   * @param {number[]} ids データ保存ID
   * @param {boolean} restricted 制限する
   * @param {string[]} sitesサイトリスト
   * @param {string} direction 限定か除外か
   * @param {string} similarityCheck 類似チェック
   */
  register(ids, restricted, sites, direction, similarityCheck) {
    return this.post(this.api + "register/", { ids, restricted, sites, direction});
  }

  /**
   * 文書一括取得
   * @param {Upload} upload
   */
  async requestTexts(upload) {
    let data = new FormData();
    upload.files.forEach((file, i) => {
      data.append(`file[${i}]`, file);
    });
    upload.urls.forEach((url, i) => {
      data.append(`url[${i}]`, url);
    });
    return fetch(this.api + "upload/", {
      method: "POST",
      body: data,
    })
      .then((response) => {
        const contentType = response.headers.get("Content-Type");
        if (contentType.startsWith(this.MSGPACK_TYPE)) {
          return this.decode(
            response.body,
            response.headers.get("Content-Length")
          );
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

const api = window.__ENABLE_MOCK__ ? new Mock() : new Api();

export { Textarea, TicketRequire, Upload, api };
